<template>
  <div class="creditAcount">
    <div class="top">
      <div class="time">
        <Calendar v-model="data_picker" @change="changeTime"></Calendar>
      </div>
      <div class="name">
        <md-icon name="search" size="xs" style="font-size: 0.24rem;padding:0.04rem"></md-icon>
        <input
          type="text"
          placeholder="搜索客户名称"
          v-model="creditQuery.searchName"
          @change="getValue"
        />
        <div @click="clearName" v-if="creditQuery.searchName">
          <md-icon name="wrong" size="md" style="font-size: 0.18rem;padding:0.04rem;color:#666"></md-icon>
        </div>
      </div>
    </div>
    <div class="totalPart" v-if="list.length>0">
      <div>
        <span>
          赊欠金额共
          <span>{{creditTotal.num*1}}</span>元，
        </span>
        <span>{{creditTotal.order_count}}单，</span>
        <span>
          还款金额
          <span>{{creditTotal.repayment*1}}</span>元，
        </span>
        <span>
          未还金额
          <span>{{creditTotal.need_repayment_amount*1}}</span>元
        </span>
      </div>
      <!-- <div class>
        <div>可视化</div>
        <div>打印</div>
      </div>-->
    </div>
    <div class="listPart" v-if="list.length>0">
      <div class="title">
        <span>序号</span>
        <span>客户名称</span>
        <span>赊欠单数</span>
        <span>赊欠金额</span>
        <span>还款金额</span>
        <span>还款优惠</span>
        <span>未还金额</span>
        <span></span>
      </div>
      <div class="list">
        <md-scroll-view
          ref="scrollView"
          :auto-reflow="false"
          :bouncing="true"
          :scrolling-x="false"
          @end-reached="$_onEndReached"
        >
          <div class="item" v-for="(item,i) in list" :key="i" @click="goDetail(item.buyer_id)">
            <span>{{i+1}}</span>
            <span>{{item.name}}</span>
            <span>{{item.order_count}}单</span>
            <span>{{item.num*1}}元</span>
            <span>{{item.repayment*1}}元</span>
            <span>{{item.discount_amount*1}}元</span>
            <span>{{item.need_repayment_amount*1}}元</span>

            <span>
              <md-icon name="arrow-right" size="sm"></md-icon>
            </span>
          </div>
          <md-scroll-view-more
            :finished-text="list.length>0?'全部已加载':'暂无数据'"
            slot="more"
            :is-finished="isFinished"
          ></md-scroll-view-more>
        </md-scroll-view>
      </div>
    </div>
    <div v-if="list.length==0" style="text-align:center;color:#999">暂无数据~</div>
  </div>
</template>
<script>
import { credit_Acount } from "@/api/work/acount/creditAcount";
import { timestampToDate } from "@/utils/timestamp";
import Calendar from "@/components/Calendar";
export default {
  name: "creditAcount",
  components: {
    Calendar,
  },
  data() {
    return {
      list: [],
      creditTotal: {
        order_count: "",
        num: "",
        need_repayment_amount: "",
        repayment: "",
      },
      data_picker: [],
      isFinished: true,
      creditQuery: {
        searchName: "",
        s: "",
        e: "",
        page: 1,
        pagesize: 55,
      },
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  methods: {
    //获取列表数据
    getList() {
      if (this.creditQuery.page == 1) {
        this.list = [];
      }
      credit_Acount(this.creditQuery).then((res) => {
        if (res.code == 200) {
          this.creditTotal.order_count = res.data.order_count;
          this.creditTotal.num = res.data.num;
          this.creditTotal.need_repayment_amount =
            res.data.need_repayment_amount;
          this.creditTotal.repayment = res.data.repayment;
          this.list = this.list.concat(res.data.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.creditQuery.page++;
          }
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    //选择时间
    changeTime(e) {
      if (this.data_picker) {
        this.creditQuery.s = timestampToDate(this.data_picker[0]);
        this.creditQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.creditQuery.s = "";
        this.creditQuery.e = "";
      }
      this.creditQuery.page = 1;
      this.list = [];
      this.getList();
    },
    //获取搜索客户名称
    getValue() {
      this.list = [];
      this.creditQuery.page = 1;
      this.getList();
    },
    //删除搜索名称
    clearName() {
      this.list = [];
      this.creditQuery.page = 1;
      this.creditQuery.searchName = "";
      this.getList();
    },
    //查看详情
    goDetail(buyer_id) {
      this.$router.push({
        path: "/data/creditAcountPart/creditAcountDetail",
        query: {
          buyer_id,
          s:this.creditQuery.s,
          e:this.creditQuery.e
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
//赊还统计
.creditAcount {
  background: #fff;
  padding: 0.2rem;
  border-radius: 0.1rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-sizing: border-box;
  height: 100%;
  .top {
    display: flex;
    margin-bottom: 0.2rem;
    height: 0.36rem;
    .name {
      display: flex;
      margin-left: 0.1rem;
      width: 3.4rem;
      height: 0.36rem;
      line-height: 0.36rem;
      border: 0.01rem solid #e5e5e5;
      align-items: center;
      line-height: 0.34rem;
      > div {
        width: 0.26rem;
        height: 0.26rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.2);
        margin-right: 0.04rem;
      }
      input {
        width: 100%;
        height: 0.28rem;
        font-size: 0.2rem;
        padding: 0.04rem;
        border: none;
      }
    }
  }
  .totalPart {
    display: flex;
    justify-content: space-between;
    margin: 0 0.22rem;
    margin-bottom: 0.2rem;
    align-items: center;
    height: 0.36rem;
    > div:nth-of-type(1) {
      span {
        font-size: 0.22rem;
        color: #404040;
        span {
          color: #31b158;
        }
      }
    }
    > div:nth-of-type(2) {
      display: flex;

      > div {
        width: 1rem;
        height: 0.36rem;
        line-height: 0.36rem;
        text-align: center;
        color: #fff;
        background: #31b158;
        border-radius: 0.04rem;
      }
      > div:nth-of-type(1) {
        margin-right: 0.3rem;
      }
    }
  }
  .listPart {
    height: calc(100% - 0.36rem - 0.36rem - 0.2rem);
    margin: 0 0.22rem;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      border-top: 0.01rem solid #e5e5e5;
      border-bottom: 0.01rem solid #e5e5e5;
      height: 0.68rem;
      > span {
        color: #555;
        font-size: 0.22rem;
        font-weight: bold;
        text-align: center;
      }
      > span:nth-of-type(1) {
        width: 0.6rem;
        text-align: left;
      }
      > span:nth-of-type(2) {
        width: 1.6rem;
      }
      > span:nth-of-type(3) {
        width: 1rem;
      }
      > span:nth-of-type(4) {
        width: 2.2rem;
      }
      > span:nth-of-type(5) {
        width: 2.2rem;
      }
      >span:nth-of-type(6){
        width: 1.6rem;
      }
      > span:nth-of-type(7) {
        width: 2.2rem;
      }
      
      > span:nth-of-type(8) {
        width: 0.8rem;
        text-align: right;
      }
    }
    .list {
      height: calc(100% - 0.68rem);
      font-size: 0.18rem;
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.6rem;
        border-bottom: 0.01rem solid #e5e5e5;
        > span {
          color: #666666;
          text-align: center;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(1) {
          width: 0.6rem;
          text-align: left;
        }
        > span:nth-of-type(2) {
          width: 1.6rem;
        }
        > span:nth-of-type(3) {
          width: 1rem;
        }
        > span:nth-of-type(4) {
          width: 2.2rem;
        }
        > span:nth-of-type(5) {
          width: 2.2rem;
        }
        >span:nth-of-type(6){
        width: 1.4rem;
      }
        > span:nth-of-type(7) {
          width: 2.2rem;
        }
        > span:nth-of-type(8) {
          width: 0.8rem;
          font-weight: bold;
          text-align: right;
        }
      }
    }
  }
}
</style>
<style lang="less">
.time {
  .calendar_select_box {
    width: 2.6rem!important;
    border: 0.01rem solid #e5e5e5!important;
    background: #fff !important;
  }
}
</style>